export default __webpack_public_path__ + "static/media/prize-2-cn.e5dcd8e3.webp";